import ProfileService from 'services/ProfileService';
import {
  FETCH_SHARED_CONTENT_REQUESTED,
  FETCH_SHARED_CONTENT_SUCCESS,
} from 'actiontypes/profile';

export const fetchSharedContentRequested = () => ({ type: FETCH_SHARED_CONTENT_REQUESTED });
export const fetchSharedContentSuccess = data => ({
  type: FETCH_SHARED_CONTENT_SUCCESS,
  payload: data,
});

export default fetchSharedContent(new ProfileService());

export function fetchSharedContent(service) {
  return ({
    characterName,
    count,
    date,
    fromId,
    offset,
  }) => async (dispatch) => {
    dispatch(fetchSharedContentRequested());
    const { data } = await service.fetchSharedContent({
      characterName,
      count,
      date,
      fromId,
      offset,
    });
    dispatch(fetchSharedContentSuccess(data));
    return data;
  };
}